import React from "react";
import { Form, Input, Button } from "antd";

const PermissionModalContent = ({ initialData, onSubmit, onCancel }) => {
  const [form] = Form.useForm();

  React.useEffect(() => {
    if (initialData) {
      form.setFieldsValue(initialData);
    }
  }, [initialData]);

  const onFinish = (values) => {
    onSubmit(values);
    setTimeout(() => {
      form.resetFields();
    }, 2000);
  };

  return (
    <Form form={form} onFinish={onFinish}>
      <Form.Item
        name="name"
        label="Name"
        rules={[{ required: true, message: "Please input a name!" }]}
      >
        <Input placeholder="view_dashboard" />
      </Form.Item>
      <Form.Item
        name="display_name"
        label="Display Name"
        rules={[{ required: true, message: "Please input a display name!" }]}
      >
        <Input placeholder="Can view dashboard" />
      </Form.Item>
      <Form.Item>
        <Button type="primary" htmlType="submit">
          {initialData ? "Update" : "Create"}
        </Button>
        <Button className="ml-2" onClick={onCancel}>
          Cancel
        </Button>
      </Form.Item>
    </Form>
  );
};

export default PermissionModalContent;
